// extracted by mini-css-extract-plugin
export var animationContainer = "_ot-0";
export var footer = "_ot-1";
export var gray = "_ot-2";
export var lineItem = "_ot-3";
export var lineItemImage = "_ot-4";
export var lineItemInfo = "_ot-5";
export var lineItemText = "_ot-6";
export var lineItems = "_ot-7";
export var modalContent = "_ot-8";
export var options = "_ot-9";
export var orderName = "_ot-a";
export var refundAmount = "_ot-b";